import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import QRModalWindow from "../../../components/AdministrativeProcedures/commonComponents/QRModalWindow/QRModalWindow";
import LoaderWithOverlay from "../../../components/GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import { APP_KNOWLEDGE_VERIFICATION_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import { getDataAppKnowledgeVerificationBySearchParams } from "../../../redux/appKnowledgeVerificationReducer/actionsAppKnowledgeVerification";

import {
  options,
  setOptionsSections,
  setOptionsProgramId,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import { API_GET_QR, MAIN_URL, PORT_FOR_INTEGRATION } from "../../../constants/constants";

import styles from "./appKnowledgeVerificationSearch.module.css";

export default function AppKnowledgeVerificationSearch() {
  const dispatch = useDispatch();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    programId: 0,
  });
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [serviceBill, setServiceBill] = useState({});
  const [isLoadingModal, setIsLoadingModal] = useState(false);

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const dataForTable = useSelector((state) => {
    const { appKnowledgeVerificationReducer } = state;
    return appKnowledgeVerificationReducer.dataForTable;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK_APP?.createAnApplication?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK_APP?.viewApplication?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK_APP?.editingAStatement?.chapterActionId,
  );

  const printQRAccess = useChapterActionIdMatch(
    sortedMenuNames?.TRAINING_CHECK_APP?.outputQR?.chapterActionId,
  );

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    dispatch(getDataAppKnowledgeVerificationBySearchParams(searchParams, 0));
    setSelectedPage(0);
    setSelectedRowData(null);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        birthDate: "",
        section: 0,
        programId: 0,
      }),
    );
    dispatch(
      getDataAppKnowledgeVerificationBySearchParams(
        {
          surname: "",
          name: "",
          midname: "",
          birthDate: "",
          section: 0,
          programId: 0,
        },
        0,
      ),
    );
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const handleButtonExtra = () => {
    setIsLoadingModal(true);
    fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR + "/" + selectedRowData.serviceBillId, {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((res) => res.blob())
      .then((blob) => {
        setIsLoadingModal(false);
        setServiceBill({
          id: selectedRowData.serviceBillId,
          QRurl: URL.createObjectURL(blob),
          onClose: () => {
            setServiceBill({});
            setShowBillContractModal(false);
          },
        });
        setShowBillContractModal(true);
      });
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataAppKnowledgeVerificationBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsAppKnowledgeVerification.key);
    }
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "programId",
        };
      });
      setOptionsProgramId(validLib, options.inputsAppKnowledgeVerification.key, "programId");
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsAppKnowledgeVerification.key);
    }
    if (dictionaryReducer.trainingProgramLibrary.length > 0) {
      const validLib = dictionaryReducer.trainingProgramLibrary.map((item) => {
        return {
          value: item.id,
          label: item.sign,
          key: "programId",
        };
      });
      setOptionsProgramId(validLib, options.inputsAppKnowledgeVerification.key, "programId");
    }
  }, []);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsAppKnowledgeVerification}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.id}
        selectedRowData={selectedRowData}
        editAccess={editAccess}
        viewAccess={viewAccess}
        addAccess={addAccess}
        externalButtonSettings={{
          btnText: "Вывести QR код",
          disabled: !selectedRowData?.serviceBillId,
          handler: handleButtonExtra,
          access: printQRAccess,
        }}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={APP_KNOWLEDGE_VERIFICATION_COLUMNS}
        data={dataForTable.content || []}
        totalPages={dataForTable.totalPages || 0}
        totalElements={dataForTable.totalElements || 0}
        selectedPage={selectedPage}
      />
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      <LoaderWithOverlay isLoading={isLoadingModal} />
    </div>
  );
}
